import { combineReducers } from 'redux';

import { StoreState } from '../interfaces';
import { EventFiltersReducer } from './eventFilters/eventFiltersReducer';
import { EventFiltersState } from './eventFilters/eventFiltersState';
import { homographyReducer } from './homography/homographyReducer';
import { HomographyState } from './homography/homographyState';
import { storeReducer } from './store/storeReducer';

export interface AppState {
  store: StoreState;
  eventFilters: EventFiltersState;
  homography: HomographyState;
}

export const rootReducer = combineReducers<AppState>({
  store: storeReducer,
  eventFilters: EventFiltersReducer,
  homography: homographyReducer,
});
